import { get } from 'lodash'

export default function(data) {
  return {
    activityLogId: get(data, 'activityLogId'),
    awardId: get(data, 'awardId'),
    participantId: get(data, 'participantId'),
    sendAsEmail: get(data, 'sendAsEmail'),
    sendAsPushNotification: get(data, 'sendAsPushNotification'),
    content: get(data, 'fields.content'),
    title: get(data, 'fields.title')
  }
}
